import Axios, { AxiosError } from "axios";
import { sentApiError } from "@/mixins/slack";

// process.env.NODE_TLS_REJECT_UNAUTHORIZED = "0";
if (process.env.NODE_ENV === "development") {
  // Axios.defaults.baseURL = process.env.VUE_APP_DOMAIN;
  // eslint-disable-next-line no-console
  console.warn(process.env.VUE_APP_DOMAIN);
}

// Axios.defaults.headers.common.Authorization = "AUTH_TOKEN";
Axios.defaults.headers.post["Content-Type"] = "application/x-www-form-urlencoded";
Axios.defaults.headers.post["X-Requested-With"] = "XMLHttpRequest";
Axios.defaults.withCredentials = true;

Axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error instanceof AxiosError && error.response?.status === 500) {
      return Promise.reject(error);
    }
    sentApiError([
      {
        title: "Api EndPoint",
        value: error.config.url,
      },
      {
        title: "Payload",
        value: error.config.data,
      },
      {
        title: "Code",
        value: error.config.code,
      },
      {
        title: "Error",
        value: error.message,
      },
    ]);
  }
);


export default Axios;
